// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__5cT-Y","head":"ProcedureTableInfo_head__rMUFn"};